<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Cancel the appointment?</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <p class="modal-description">
        Do you want to cancel the appointment? This action is permanent and cannot be undone.
      </p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="button-container">
        <button class="btn btn-secondary" (click)="onConfirm()">
          Yes, cancel
        </button>
        <button class="btn btn-primary" (click)="onCancel()">
          No, I don't want to cancel
        </button>
      </div>
    </div>
  </div>
</div>
